export const gitCommit = 'f5ef1b2f'
